export default {
  name: 'General Mills',
  domain: 'gm',
  id: '5ea71be34d8640000186369f',
  slug: 'general-mills-regen-ag',
  path: '/general-mills-regen-ag/',
  logo: '/partners/gm/img/logo.png',
  themes: {
    light: {
      primary: '#0055a7',
      secondary: '#82AF9C',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#82AF9C',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
